import Vue from "vue";
import moment from "moment-timezone";
import store from "@/store";
import i18n from "@/plugins/i18n.js";
import _ from "lodash";
const beforeMidNight = "23:59:00";
function isMorning(time) {
  const format = "HH:mm:ss";
  const givenMoment = moment(time, format);
  const noonMoment = moment("12:00:00", format);

  // Check if givenTime is before noon
  return givenMoment.isBefore(noonMoment);
}
function isTimeInRange(givenTime, openTime) {
  const format = "HH:mm:ss";

  const givenMoment = moment(givenTime, format);
  const openMoment = moment(openTime, format);
  const midnightMoment = moment("00:00:00", format);

  // Check if givenTime is between midnight and openTime
  return givenMoment.isBetween(midnightMoment, openMoment, undefined, "[)");
}
function isSameDay(date1, date2) {
  const format = "YYYY-MM-DD";

  const formattedDate1 = moment(date1, format);
  const formattedDate2 = moment(date2, format);

  return formattedDate1.isSame(formattedDate2, "day");
}
function calculateIntervals(
  open,
  closing,
  nightOpen,
  nightClosing,
  nextPossibleTime,
  latestTimeBeforeClosing
) {
  const format = "HH:mm:ss";
  const interval = 15; // 15-minute intervals

  const generateIntervals = (startTime, endTime) => {
    const intervals = [];
    let currentMoment = moment(startTime, format);

    while (currentMoment.isBefore(moment(endTime, format))) {
      intervals.push({
        value: currentMoment.format(format),
        name: currentMoment.format("HH:mm"),
      });
      currentMoment.add(interval, "minutes");
    }

    return intervals;
  };

  const adjustLastInterval = (intervals, lastTime) => {
    if (intervals.length > 0 && latestTimeBeforeClosing) {
      const lastInterval = intervals[intervals.length - 1];
      const adjustedTime = moment(lastTime, format)
        .subtract(latestTimeBeforeClosing, "minutes")
        .format(format);

      lastInterval.value = adjustedTime;
      lastInterval.name = adjustedTime;
    }
  };
  const regularIntervals = generateIntervals(open, closing);
  if (closing !== beforeMidNight) {
    adjustLastInterval(regularIntervals, closing);
  }

  let nightIntervals = [];
  if (nightOpen && nightClosing) {
    nightIntervals = generateIntervals(nightOpen, nightClosing);
    adjustLastInterval(nightIntervals, nightClosing);
  }

  const allIntervals = _.orderBy(
    [...regularIntervals, ...nightIntervals],
    "value"
  );

  if (nextPossibleTime) {
    const filteredIntervals = allIntervals.filter((interval) =>
      moment(interval.value, format).isSameOrAfter(
        moment(nextPossibleTime, format)
      )
    );
    return filteredIntervals;
  }

  return allIntervals;
}
const storeDeliveryTimes = {
  install(Vue) {
    Vue.prototype.$appStoreDeliveryTimes = {
      dates: function (scheduleFirstDate) {
        var array = [];
        var week = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
        ];
        var schedule;
        if (store.getters.deliveryMethod === "delivery-service") {
          //get deliveryHours
          schedule = store.getters.storeInfo.deliveryHours;
        } else {
          //get openingHours
          schedule = store.getters.storeInfo.openingHours;
        }

        for (
          let index = 0;
          index <
          (store.getters.deliveryMethod === "delivery-service"
            ? store.getters.storeInfo.deliveryPartnerFutureOrderDays ??
              store.getters.storeInfo.configs.allowedOrderInFutureDays
            : store.getters.storeInfo.configs.allowedOrderInFutureDays);
          index++
        ) {
          var exist = _.find(schedule, {
            dayName:
              week[moment(new Date(scheduleFirstDate)).add(index, "d").day()],
            isClosed: 0,
          });
          if (exist) {
            if (index > 6) {
              array.push({
                value: moment(new Date(scheduleFirstDate))
                  .add(index, "d")
                  .format("YYYY-MM-DD"),
                name: moment(new Date(scheduleFirstDate))
                  .add(index, "d")
                  .format("YYYY-MM-DD"),
              });
            } else {
              let dayname;
              switch (true) {
                case index < 2 &&
                  moment(new Date(scheduleFirstDate)).add(index, "d").day() ===
                    moment(new Date()).add(0, "d").day():
                  dayname = "today";
                  break;
                case index < 2 &&
                  moment(new Date(scheduleFirstDate)).add(index, "d").day() ===
                    moment(new Date()).add(1, "d").day():
                  dayname = "tomorrow";
                  break;
                default:
                  dayname =
                    week[
                      moment(new Date(scheduleFirstDate)).add(index, "d").day()
                    ];
              }

              array.push({
                value: moment(new Date(scheduleFirstDate))
                  .add(index, "d")
                  .format("YYYY-MM-DD"),
                name: i18n.t("days." + dayname),
              });
            }
          }
        }
        return array;
      },
      // times: function (date, scheduleFirstDate, scheduleFirstTime) {
      //   if (scheduleFirstTime) {
      //     var array = [];
      //     var start = "";
      //     var open = "";
      //     var end = "";
      //     var close = "";
      //     var week = [
      //       "sunday",
      //       "monday",
      //       "tuesday",
      //       "wednesday",
      //       "thursday",
      //       "friday",
      //       "saturday",
      //     ];
      //     var deliveryHours = store.getters.storeInfo.deliveryHours;
      //
      //     var foundItem = _.find(deliveryHours, {
      //       dayName: week[moment(new Date(date)).day()],
      //     });
      //
      //     //today
      //     if (date == scheduleFirstDate) {
      //       start = new Date("0001-01-01T" + scheduleFirstTime);
      //       open = start.getHours() * 60 + start.getMinutes();
      //     } else {
      //       start = new Date("0001-01-01T" + foundItem.open);
      //       open = start.getHours() * 60 + start.getMinutes();
      //     }
      //     end = new Date("0001-01-01T" + foundItem.closing);
      //     close = end.getHours() * 60 + end.getMinutes();
      //
      //     // var horaFin = 12 * 60;
      //     var interval = 15;
      //
      //     while (open < close) {
      //       var hora = parseInt(open / 60);
      //       var minutos = parseInt(open) % 60;
      //
      //       var name =
      //         (hora < 10 ? "0" + hora : hora) +
      //         ":" +
      //         (minutos < 10 ? "0" + minutos : minutos);
      //       var value =
      //         (hora < 10 ? "0" + hora : hora) +
      //         ":" +
      //         (minutos < 10 ? "0" + minutos : minutos) +
      //         ":00";
      //       array.push({ name: name, value: value });
      //       open = open + interval;
      //     }
      //
      //     return array;
      //   } else {
      //     return;
      //   }
      // },
      timesX: function (date, scheduleFirstDate, scheduleFirstTime) {
        const week = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
        ];
        let deliveryHours;
        if (store.getters.deliveryMethod === "delivery-service") {
          //get deliveryHours
          deliveryHours = store.getters.storeInfo.deliveryHours;
        } else {
          //get openingHours
          deliveryHours = store.getters.storeInfo.openingHours;
        }
        const foundItem = _.find(deliveryHours, {
          dayName: week[moment(new Date(date)).day()],
          isClosed: 0,
        });
        const result = isSameDay(date, scheduleFirstDate);
        let nightOpenTime = foundItem.nightOpen;
        const initialTime = moment(
          `${date} ${foundItem.open}`,
          "YYYY-MM-DD HH:mm:ss"
        );
        let openTime = foundItem.open;
        let closeTime;
        const nextPossibleTimeFromMidnight = isTimeInRange(
          `${scheduleFirstTime}:00`,
          foundItem.closing
        );
        if (result) {
          openTime = nextPossibleTimeFromMidnight
            ? openTime
            : `${scheduleFirstTime}:00`;
        } else {
          const resultX = isMorning(foundItem.open);
          if (!resultX) {
            openTime = initialTime
              .add(
                store.getters.storeInfo?.configs?.earliestTimeBeforeOpening ??
                  15,
                "minutes"
              )
              .format("HH:mm:ss");
          } else {
            const isEvening = isMorning(foundItem.closing);
            if (!isEvening) {
              openTime = initialTime
                .add(
                  store.getters.storeInfo?.configs?.earliestTimeBeforeOpening ??
                    15,
                  "minutes"
                )
                .format("HH:mm:ss");
            }
          }
        }
        const givenTime = foundItem.closing;
        const opening = foundItem.open;
        const resultX = isTimeInRange(givenTime, opening);
        if (!resultX) {
          closeTime = foundItem.closing;
        } else {
          closeTime = beforeMidNight;
        }
        const latestTimeBeforeClosing =
          store.getters.storeInfo?.configs?.latestTimeBeforeClosing;
        if (nextPossibleTimeFromMidnight) {
          nightOpenTime = `${scheduleFirstTime}:00`;
        }
        if (result) {
          return calculateIntervals(
            openTime,
            closeTime,
            nightOpenTime,
            foundItem.nightClosing,
            `${scheduleFirstTime}:00`,
            latestTimeBeforeClosing > 0 ? latestTimeBeforeClosing : undefined
          );
        }
        return calculateIntervals(
          openTime,
          closeTime,
          nightOpenTime,
          foundItem.nightClosing,
          undefined,
          latestTimeBeforeClosing > 0 ? latestTimeBeforeClosing : undefined
        );
      },
      maxDayOrder: function (date, days) {
        let newDate = moment(new Date(date)).add(days, "d");
        return moment(newDate).format("YYYY-MM-DD");
      },
    };
  },
};
Vue.use(storeDeliveryTimes);
